import { api } from './api';

/* Коды счётчиков из админки (Метрика, Mixpanel…) — в <head> после загрузки приложения, а не в index.html:
   их правят в админке без пересборки, а недоступный сервер счётчика не задерживает показ (белый экран).
   <script> из innerHTML не выполняется — пересоздаём каждый со всеми атрибутами; остальное (noscript, meta, link) — как есть. */
export function injectHead(html: string) {
  if (!html.trim()) return;
  const tpl = document.createElement('template');
  tpl.innerHTML = html;
  tpl.content.childNodes.forEach((n) => {
    if (n.nodeType !== 1) return;
    const el = n as Element;
    if (el.tagName === 'SCRIPT') {
      const s = document.createElement('script');
      for (const a of Array.from(el.attributes)) s.setAttribute(a.name, a.value);
      s.text = el.textContent || '';
      document.head.appendChild(s);
    } else document.head.appendChild(document.importNode(el, true));
  });
}

let done = false;
/** Один раз за загрузку; ошибки счётчика не трогают приложение */
export function loadCounters(app: 'trainer' | 'client') {
  if (done) return;
  done = true;
  setTimeout(() => {
    api.auth.head
      .query({ app })
      .then((html) => {
        try {
          injectHead(html);
        } catch (e) {
          console.warn('Счётчики: не удалось вставить код', e);
        }
      })
      .catch(() => {});
  }, 0);
}
